import React from 'react';
import CustomerRoute from 'components/Tvendo/Sale/DataMaster/CustomerRoute/List.js';

export default function () {
  return <CustomerRoute />;
}
